import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { Comparator, dateFilter } from 'react-bootstrap-table2-filter'
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import PropType  from 'prop-types';

import { InputField, List , NavLink} from '../index';
import { PaginationPanel, PaginationTotal } from './';
import { PAGE_SIZE } from '../../config/pagination';
import { getIconUrl } from '../../common/images-catalogue';
//const INITIAL_PRODUCTS_COUNT = 8;


const generateRow = (data) => ({
    id: data.id,
    bill: data,
    client: data,
    dueDate: data,
    details: data,
    status: data
});

const billInfo = (data) => {
   
    return (
        <ContextMenuTrigger id="bills_table_context_menu">
        <div className="bill-info">
            <div className="bill-info-holder">
                <div className="bill-info-content">
                    <h3>{data.referenceNo}</h3>
                </div>
            </div>
        </div>
        </ContextMenuTrigger>
    );
}

const clientsInfo = (data) => {
    const clientName = data.account.clientInfo.officeName ? data.account.clientInfo.officeName  : `${data.account.clientInfo.firstName} ${data.account.clientInfo.lastName}`;
    return (
        <ContextMenuTrigger id="bills_table_context_menu">
        <div className="client-info">
            <div className="client-info-holder">
                <div className="client-info-content">
                    <h3>{clientName}</h3>
                    <p className="info">{data.account.accountNo}</p>
                </div>
            </div>
        </div>
        </ContextMenuTrigger>
    );
}

const dueCell = (data) => {
    const overdueClassname = data.billInsight.isPastDue && data.billInsight.dueDays < 0 ? '--overdue' : '';
    return (
        <ContextMenuTrigger id="bills_table_context_menu">
        <div className="due-info">
            <div className="due-info-holder">
                <div className="due-info-content">
                    <h3 className={`${overdueClassname}`}>{data.billInsight.dueDateAsDays}</h3>
                    <p className="info">{data.dueDate}</p>
                </div>
            </div>
        </div>
        </ContextMenuTrigger>
    );
}

const billDetails = (data) => {
    //return function with cell content

    return (
        <div className="bill-details">
            <ContextMenuTrigger id="bills_table_context_menu">
            <div className="bill-details-holder">
                <div className="bill-details-content">
                    <p className="info">Balance: <span className="highlight">${data.amountDue.toCurrency()}</span></p>
                    <p className="info">Paid:  <span className="highlight prev-balc">${data.amountPaid.toCurrency()}</span></p>
                </div>
            </div>
            </ContextMenuTrigger>
        </div>
    );
}

const statusInfo = (actions) => {
    
    return (data) => {
        const statusClassname = data.status.toLowerCase();
        
        return (
        <ContextMenuTrigger id="bills_table_context_menu">
        <div className="client-info">
            <div className="toolbar">
                <List className="action-menu">
                    <li className="action-item">
                        <NavLink actiontag="view" onClick={actions.editAction}>
                            <span className="icon"><img className="icon" src={getIconUrl("edit")} alt='' /></span>
                        </NavLink>
                    </li>
                    <li className="action-item">
                        <NavLink >
                            <span className="icon"><img className="icon" src={getIconUrl("option")} alt='' /></span>
                        </NavLink>
                    </li>
                </List>
            </div>
            <div className="status-info-holder">
                <div className="status-info-content">
                    <span className={`status --${statusClassname}`}>{data.status}</span>
                </div>
            </div>
        </div>
        </ContextMenuTrigger>
    )};
}

class BillTable extends React.Component { 
    static propsTypes = {
        tableData: PropType.array.require,
        actionResponsers: PropType.object,
    }

    static defaultProps = {
        actionResponsers: {
            editButton: null,
        }
    }

    constructor(props) {
        super(props);
        
        this.state = {
            //tableData: _.times(INITIAL_PRODUCTS_COUNT, generateRow),
            selected: [],
            rowInFocus: null
        };
        this.table = React.createRef();
        this.willEnterRow = this.willEnterRow.bind(this);
        this.didClickRow = this.didClickRow.bind(this);
        this.didContextClick = this.didContextClick.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
    }

    createColumnDefinitions(quickActions) { 
        return [
            {
                dataField: 'bill',
                text: "Ref#",
                headerAttrs: {
                    hidden: false,
                    className: 'th-patient-cell',
                },
                classes: 'id-patient-cell td-cell',
                formatter: billInfo
            },
            {
                dataField: 'client',
                text: "Client",
                headerAttrs: {
                    hidden: false,
                    className: 'th-client-cell',
                },
                classes: 'id-client-cell td-cell',
                formatter: clientsInfo
            },
            {
                dataField: 'dueDate',
                text: "Due Date",
                headerAttrs: {
                    hidden: false,
                    className: 'th-workspace-cell',
                },
                classes: 'id-workspace-cell td-cell',
                formatter: dueCell
            },
            {
                dataField: 'details',
                text: "Details",
                headerAttrs: {
                    hidden: false,
                    className: 'th-details-cell',
                },
                classes: 'id-details-cell td-cell',
                formatter: billDetails
            },
            {
                dataField: 'status',
                text: "Status",
                headerAttrs: {
                    hidden: false,
                    className: 'th-status-cell',
                },
                classes: 'id-status-cell td-cell',
                formatter: statusInfo(quickActions)
            },
        ];
    }

    handleSelect() {}

    handleSelectAll() {}

    handleOnChange() {}

    willEnterRow (evt, row, rowIndex) {
        const bill = this.props.tableData.find((item) => {
            return item.id === row.id;
        });
        
        this.props.hoverOverRowAction({bill});
    }

    didClickRow(evt, row, index) {
        const rowId = evt.target.getAttribute('rowid');
        const actionTag = evt.target.getAttribute('actiontag');
        if (rowId && actionTag && actionTag === 'view') {
            this.props.quickActions.viewDetails(row.bill);
        }
    }  

    didContextClick (evt, row, rowIndex) {
        evt.preventDefault();
    }

    onTableChange(evt, opt) {
        this.props.onTableChange && this.props.onTableChange(opt);
    }

    render () {
        const columnDefs = this.createColumnDefinitions(this.props.quickActions);
        const paginationDef = paginationFactory({
            paginationSize: 5,
            sizePerPage: this.props.metaData?.pageSize || PAGE_SIZE,
            showTotal: true,
            totalSize: this.props.metaData?.totalItems || 0,
            page: this.props.metaData?.currentPage + 1 || 0,
            pageListRenderer: (props) => (
                <PaginationPanel { ...props } size="sm" className="ml-md-auto mt-2 mt-md-0" />
            ),
            paginationTotalRenderer: (from, to, size) => (
                <PaginationTotal { ...{ from, to, size } } />
            )
        
        });
        const selectRowConfig = {
            mode: 'checkbox',
            selected: this.state.selected,
            onSelect: this.handleSelect.bind(this),
            onSelectAll: this.handleSelectAll.bind(this),
            selectionRenderer: ({ mode, checked, disabled }) => (
                <InputField id="" onChange={this.handleOnChange} type={ mode } checked={ checked } disabled={ disabled } />
            ),
            selectionHeaderRenderer: ({ mode, checked, indeterminate }) => (
                <InputField id="" onChange={this.handleOnChange} type={ mode } checked={ checked } innerRef={el => el && (el.indeterminate = indeterminate)} />
            )
        };

        const rowEventsHandlers = {
            onContextMenu: this.didContextClick,
            onMouseEnter: this.willEnterRow,
            onClick: this.didClickRow
        };

        var options = {
            noDataMessage: () => 'No bills found.'
        };

        //const billsData = this.state.tableData;
        const billsData = this.props.tableData.map(bill => generateRow(bill));
        
        return (
            <ToolkitProvider
                keyField="id"
                data={ billsData }
                columns={columnDefs} >
                {
                    props => (
                        <React.Fragment>
                            
                            <BootstrapTable
                            ref={this.table}
                            remote={{ pagination: this.props.pagable}}
                            classes="table-responsive bills-table"
                            pagination={ paginationDef }
                            filter={ filterFactory() }
                            selectRow={ selectRowConfig }
                            bordered={ false }
                            responsive
                            { ...props.baseProps }
                            rowEvents={ rowEventsHandlers }
                            loading={ true } 
                            noDataIndication={options.noDataMessage}
                            onTableChange={this.onTableChange}
                        />
                        </React.Fragment>
                    )
                }
            </ToolkitProvider>
        );
    }
}

export { BillTable }